
import { ADMIN_ACCOUNT_VERIFIED } from "@/constants/MixpanelEvents.js";
import { mapState, mapActions } from "vuex";
import MobileEmailTab from "../components/common/mobile-email-tab.vue";
import signupOtp from "../components/user/signup-otp.vue";
import userSignup from "../components/user/user-signup.vue";
import otpVerification from "../components/common/otp-verification.vue";
export default {
  components: {
    signupOtp,
    userSignup,
    MobileEmailTab,
    otpVerification
  },
  layout: "blankLogo",
  data() {
    return {
      state: "",
      signupData: {},
      SIGNUP_OTP_VERIFICATION: "signup-otp-verfication",
      LOGIN_SIGNUP: "login-signup",
      signupOtpVerification: false,
      resetOtpTimer: false,
      loading: false
    };
  },
  mounted() {
    if (this.$route.params?.password) {
      this.switchToSignupOtpVerification(this.$route.params);
    } else {
      this.state = this.LOGIN_SIGNUP;
    }
  },
  computed: {
    isEmailOtp() {
      return !!(this.signupData?.email || this.$route.params.email);
    }
  },
  methods: {
    ...mapActions("auth", [
      "verifySignupMobileOtp",
      "verifySignupEmailOtp",
      "requestSignupMobileOtp",
      "requestSignupEmailOtp",
      "login"
    ]),
    switchToSignupOtpVerification(signupData, response) {
      this.signupData = signupData;
      this.state = this.SIGNUP_OTP_VERIFICATION;
    },
    submitOtp(otp) {
      const $this = this;
      this.loading = true;
      const payload = {
        otp_code: otp.toString()
        // platform: "web"
      };
      if (!this.isEmailOtp) {
        payload.mobile_number =
          this.signupData.mobile.country_code + this.signupData.mobile.number;
      } else {
        payload.email = this.signupData.email;
      }
      const verify = this.isEmailOtp
        ? this.verifySignupEmailOtp
        : this.verifySignupMobileOtp;
      verify(payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.mixPanelTrackEvent(ADMIN_ACCOUNT_VERIFIED);
            var bodyFormData = new FormData();
            bodyFormData.append("platform", "web");
            if (this.isEmailOtp) {
              bodyFormData.append("email", this.signupData.email);
            } else {
              bodyFormData.append(
                "mobile_number",
                this.signupData.mobile.country_code +
                  this.signupData.mobile.number
              );
            }

            bodyFormData.append("password", this.signupData.password);

            this.login(bodyFormData)
              .then((res) => {
                if (!res.data.business?.id) {
                  this.$router.push({
                    name: "restaurant-create-restaurant"
                  });
                } else {
                  this.$router.push({
                    name: "food-menu"
                  });
                }
              })
              .catch((err) => {
                this.$router.push({
                  name: "login-signup"
                });
              });
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtp() {
      this.resetOtpTimer = false;
      let request, payload;
      if (this.isEmailOtp) {
        request = this.requestSignupEmailOtp;
        payload = {
          email: this.signupData.email,
          service: "email_verification",
          platform: "web"
        };
      } else {
        request = this.requestSignupMobileOtp;
        payload = {
          mobile_number:
            this.signupData.mobile.country_code + this.signupData.mobile.number,
          service: "mobile_verification",
          platform: "web"
        };
      }
      request(payload)
        .then((response) => {
          this.resetOtpTimer = true;
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        });
    }
  }
};
